var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 259.9 475.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99,475.3V420c-39-1.7-76.9-12.2-99-25l17.5-68.1c24.5,13.4,58.8,25.6,96.7,25.6,33.2,0,55.9-12.8,55.9-36.1,0-22.1-18.6-36.1-61.7-50.7C46.1,244.7,3.6,215.6,3.6,159.1c0-51.3,36.1-91.4,98.4-103.7V0h57.1V51.3c39,1.7,65.2,9.9,84.5,19.2l-16.9,65.8c-15.1-6.4-41.9-19.8-83.9-19.8-37.9,0-50.1,16.3-50.1,32.6,0,19.2,20.4,31.5,69.9,50.1,69.3,24.5,97.3,56.5,97.3,108.9,0,51.8-36.7,96.1-103.7,107.8v59.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/usd.cba334654368fd0a8ddb68ceac5717c7.svg";
export { ForwardRef as ReactComponent };